import * as z from 'zod';

export const schema = z.object({
  location: z.string().optional(),
  centerlat: z.number().optional(),
  centerlng: z.number().optional(),
  locationType: z.string().optional(),
  locationAccuracy: z.string().optional(),
  rawLocationTypes: z.array(z.string()).optional(),
});

export type Schema = typeof schema;
export type FormState = z.infer<Schema>;
